import React from "react";
import { Grid, Box, Link } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ProjectLogo from "../../Assets/Images/Login/PSCAdminPortalLogin.svg";
import { FaLinkedinIn, FaTelegramPlane } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { motion } from "framer-motion";

const LandingPageFooter = () => {
  const navigate = useNavigate();
  
  // Get current year dynamically
  const currentYear = new Date().getFullYear();
  
  return (
    <Box
      sx={{
        backgroundColor: "#333333",
        color: "#fff",
        padding: { xs: "3%", md: "4% 6%" },
        minHeight: "auto",
      }}
    >
      <Grid container spacing={4} justifyContent="center" sx={{ margin: "0 auto" }}>
        <Grid item xs={12} sm={6} md={4} textAlign={{ xs: "center", sm: "left" }}>
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5 }}>
            <img
              src={ProjectLogo}
              alt="ProjectLogo"
              role="presentation"
              className="pointer"
              onClick={() => navigate("/")}
              style={{ width: 60, height: 60 }}
            />
          </motion.div>
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: 0.1 }}>
            <h4 className="poppinsMedium Text-Prime-White mt-3 w-100">POLICE SERVICE COMMISSION</h4>
          </motion.div>
          <Box sx={{ mt: 3, display: "flex", gap: 1, justifyContent: { xs: "center", sm: "left" } }}>
            <Link href="#" color="inherit">
              <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.4 }}>
                <FaLinkedinIn color={"#44FFB8"} size={20} />
              </motion.div>
            </Link>
            <Link href="#" color="inherit">
              <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.4, delay: 0.05 }}>
                <FaTelegramPlane color={"#44FFB8"} size={20} />
              </motion.div>
            </Link>
            <Link href="#" color="inherit">
              <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.4, delay: 0.1 }}>
                <FaXTwitter color={"#44FFB8"} size={20} />
              </motion.div>
            </Link>
          </Box>
        </Grid>

        {/* Important Links */}
        <Grid item xs={12} sm={2.2}>
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5 }}>
            <h4 style={{ color: "#44FFB8", textDecoration: "underline" }} className="poppinsMedium Text-Prime-White text-left w-100">Important Links</h4>
          </motion.div>
          <Box>
            <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: 0.05 }}>
              <p className="poppinsRegular landingFooterText text-left pointer pt-3" role="presentation" onClick={() => window.open("https://psc.gov.ng/about/", "_blank")}>About the Commission</p>
              <p className="poppinsRegular landingFooterText text-left pointer pt-2" role="presentation" onClick={() => window.open("https://psc.gov.ng/news/", "_blank")}>News/Press Release</p>
              <p className="poppinsRegular landingFooterText text-left pointer pt-2" role="presentation" onClick={() => window.open("https://psc.gov.ng/policies/", "_blank")}>Terms & Conditions</p>
              <p className="poppinsRegular landingFooterText text-left pointer pt-2" role="presentation" onClick={() => window.open("https://psc.gov.ng/policies/", "_blank")}>Privacy Policy</p>
            </motion.div>
          </Box>
        </Grid>

        {/* Hours Section */}
        <Grid item xs={12} sm={6} md={2.8}>
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5 }}>
            <h4 style={{ color: "#44FFB8", textDecoration: "underline" }} className="poppinsMedium Text-Prime-White text-left w-100">Hours</h4>
            <p style={{ color: "#F2F2F2" }} className="poppinsRegular text-left pointer pt-3">Monday–Friday: 8:00AM–4:00PM</p>
            <p style={{ color: "#F2F2F2" }} className="poppinsRegular text-left pointer pt-1">(Except on Public Holidays)</p>
          </motion.div>
        </Grid>

        {/* Contact Us Section */}
        <Grid item xs={12} sm={12} md={3}>
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5 }}>
            <h4 style={{ color: "#44FFB8", textDecoration: "underline" }} className="poppinsMedium Text-Prime-White text-left w-100">Contact Us</h4>
            <p className="poppinsRegular landingFooterText text-left pointer pt-3">Police Service Commission, Corporate Headquarters, Plot 644, Cadastral Zone 6X, Sector Centre B, Jabi, Abuja</p>
            <p className="poppinsRegular landingFooterText text-left pointer pt-2">+2347034702676, +2347034702677</p>
            <p className="poppinsRegular landingFooterText text-left pointer pt-2" role="presentation" onClick={() => window.open("mailto:info@psc.gov.ng", "_blank")}>info@psc.gov.ng</p>
            <p className="poppinsRegular landingFooterText text-left pointer pt-2">P.M.B. 5186</p>
          </motion.div>
        </Grid>

      </Grid>

      {/* Copyright Section */}
      <Box
        sx={{
          textAlign: "center",
          mt: { xs: 3, md: 4 },
          borderTop: "1px solid #555",
          pt: 2,
          margin: "0 auto",
        }}
      >
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5 }}>
          <p style={{ color: "#F2F2F2" }} className="poppinsRegular text-center pointer">Copyright © {currentYear}, ICT Division, Police Service Commission</p>
        </motion.div>
      </Box>
    </Box>
  );
};

export default LandingPageFooter;
